import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";

const INSTAGRAM_URL =
  "https://www.instagram.com/irlstats?igsh=MXJ4ajI1YTR0Ynh2OA%3D%3D&utm_source=qr";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-amber-500/15 bg-black"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-12 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <img
              src="https://customer-assets.emergentagent.com/job_irl-stats-launch/artifacts/11a33vjr_irl%20stats%201.png"
              alt="IRL Stats logo"
              className="h-10 w-10 rounded-lg shadow-[0_0_18px_-4px_rgba(251,191,36,0.45)]"
            />
            <span className="font-cinzel text-amber-100 tracking-[0.18em] uppercase text-base">
              IRL Stats
            </span>
          </div>
          <p className="text-stone-400 text-sm leading-relaxed max-w-xs">
            Level up your fitness. Track real workouts, earn real XP, and unlock
            real progression.
          </p>
          <p className="text-stone-600 text-xs mt-4">
            The Legacy Labs LLC, dba IRL Stats
          </p>
        </div>

        <div>
          <h4 className="font-cinzel text-amber-200 uppercase tracking-[0.18em] text-sm mb-4">
            Legal
          </h4>
          <ul className="space-y-3">
            <li>
              <Link
                to="/privacy"
                data-testid="footer-link-privacy"
                className="text-stone-300 hover:text-amber-300 text-sm transition-colors"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                to="/terms"
                data-testid="footer-link-terms"
                className="text-stone-300 hover:text-amber-300 text-sm transition-colors"
              >
                Terms of Service
              </Link>
            </li>
            <li>
              <Link
                to="/support"
                data-testid="footer-link-support"
                className="text-stone-300 hover:text-amber-300 text-sm transition-colors"
              >
                Support
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-cinzel text-amber-200 uppercase tracking-[0.18em] text-sm mb-4">
            Contact
          </h4>
          <ul className="space-y-3">
            <li>
              <a
                href="mailto:irlstatsapp@gmail.com"
                data-testid="footer-link-email"
                className="inline-flex items-center gap-2 text-stone-300 hover:text-amber-300 text-sm transition-colors"
              >
                <Mail size={14} />
                irlstatsapp@gmail.com
              </a>
            </li>
            <li>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-link-instagram"
                className="inline-flex items-center gap-2 text-stone-300 hover:text-amber-300 text-sm transition-colors"
              >
                <Instagram size={14} />
                @irlstats
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-amber-500/10">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-stone-500 text-xs">
            © {new Date().getFullYear()} The Legacy Labs LLC. All rights reserved.
          </p>
          <p className="text-stone-600 text-xs tracking-wider uppercase">
            Built for the grind
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
